import ExamRoomLayout from './ExamRoomLayout';

export default ExamRoomLayout;
